import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { AdvancedMentoringProductDTO, BasicMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { useMemo, useState } from 'react';
import { useUpdateMentoringProductOnTabChange } from './AdvancedMentoring/_hooks/updateMentoringProductOnTabChange';
import { getDefaultAdvancedProduct } from './AdvancedMentoring/_hooks/useInitMentoringProductWithMentoringDetailsData';
import { getDefaultBasicProduct } from './BasicMentoring';
export function useMentoringProducts(subscription) {
  const $ = _c(10);
  let t0;
  if ($[0] !== subscription) {
    t0 = () => getDefaultAdvancedProduct(subscription);
    $[0] = subscription;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [advancedProduct, setAdvancedProduct] = useState(t0);
  let t1;
  if ($[2] !== advancedProduct || $[3] !== subscription) {
    t1 = {
      mentoringProduct: advancedProduct,
      subscription,
      setMentoringProduct: setAdvancedProduct
    };
    $[2] = advancedProduct;
    $[3] = subscription;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useUpdateMentoringProductOnTabChange(t1);
  let t2;
  if ($[5] !== subscription) {
    t2 = getDefaultBasicProduct(subscription);
    $[5] = subscription;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const basicProduct = t2;
  let t3;
  if ($[7] !== advancedProduct || $[8] !== basicProduct) {
    t3 = {
      advancedProduct,
      setAdvancedProduct,
      basicProduct
    };
    $[7] = advancedProduct;
    $[8] = basicProduct;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}